import { apiFetch } from './client';
export function projectFieldToApi(field, value) {
    switch (field) {
        case 'stake':
            return { stakeholders: value };
        case 'deps':
            return { dependencies: value };
        case 'ab':
            return { abTest: value };
        case 'effectComment':
            return { effectComment: value };
        case 'type':
            return { type: value === '—' ? '' : value };
        case 'priority':
            return { priority: value === '—' ? '' : value };
        default:
            return { [field]: value };
    }
}
export async function patchProject(projectId, payload) {
    await apiFetch(`/projects/${projectId}`, {
        method: 'PATCH',
        body: JSON.stringify(payload),
    });
}
export async function createProject(sectionId, payload) {
    const row = await apiFetch(`/sections/${sectionId}/projects`, {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    return row;
}
export async function moveProject(projectId, sectionId) {
    await apiFetch(`/projects/${projectId}/move`, {
        method: 'POST',
        body: JSON.stringify({ sectionId }),
    });
}
